<template>
  <v-dialog
    max-width="500"
    v-model="modal">
    <template v-slot:default="dialog">
      <v-card
        class="rounded-lg d-flex flex-column"
        style="min-height: 300px;">
        <v-card-title
          class="pt-9 px-12">
          <v-row
            class="text-center d-flex justify-start">
            <span
              class="text-h6 font-weight-bold primary--text">
              Detalhes do Beneficiário
            </span>
            <v-spacer />
            <v-icon
              size="25"
              color="grey"
              @click="close">
              close
            </v-icon>
          </v-row>
        </v-card-title>
        <v-card-text
          class="px-9 pt-5 d-flex flex-column flex-grow-1">
          <p
            class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
            Data/hora da criação do Registro
          </p>
          <p
            class="pb-0 text-body-2 mb-3">
            {{ beneficiary.createdAt ? formatter.formatDateTimeZoneWithHours(beneficiary.createdAt) : '-' }}
            {{ beneficiary.createdLogin ? `por ${beneficiary.createdLogin}` : '' }}
            {{ beneficiary.createdProcess ? 'via ' + getCreatedProcess(beneficiary.createdProcess) : '-' }}
          </p>

          <p
            class="mb-0 pb-0 text-subtitle-2 font-weight-bold">
            Data/hora da última alteração
          </p>
          <p
            class="pb-0 text-body-2 mb-3">
            {{ beneficiary.updatedAt ? formatter.formatDateTimeZoneWithHours(beneficiary.updatedAt) : '-' }}
            {{ beneficiary.updatedLogin ? `por ${beneficiary.updatedLogin}` : '-' }}
          </p>

        </v-card-text>
        <v-card-actions
          class="px-9 pb-9">
          <v-row
            no-gutters>
            <v-spacer />
            <v-btn
              class="text-body-2 elevation-0 primary--text"
              height="40"
              color="fog"
              @click="close">
              <v-icon
                left>
                fas fa-arrow-left
              </v-icon>
              Fechar
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import CoverageMixin from '@/shared/mixins/coverage/coverageMixin';
import Formatters from '@/shared/formatters/formatters';
import moment from 'moment';
export default {
  name: "BeneficiaryDetailModal",

  data: () => ({
    moment,
    modal: false,
    formatter: null,
    beneficiary: null,
    coverages: [],
  }),

  mixins: [
    CoverageMixin,
  ],

  methods: {
    open(item) {
      this.beneficiary = item;
      this.modal = true;
    },
    close() {
      this.modal = false;
      this.beneficiary = false;
    },
    getCreatedProcess(process) {
      if (process === 'MOVEMENT') return 'Movimentação Cadastral';
      if (process === 'CADASTRAL_POSITION') return 'Posição Cadastral';
      if (process === 'AUTOMATIC') return 'Integração Automática';
      return '';
    },
  },

  created() {
    this.formatter = new Formatters();
  },

  async beforeMount() {
    await this.fetchCoverages()
      .then((result) => this.coverages = result)
      .catch((error) => this.$emit('showError', 'Erro na busca pelos motivos de permanência'));
  },
}
</script>